// extracted by mini-css-extract-plugin
export default {"deleteButton":"NNv9W"};